import storage from 'local-storage-fallback'

const getItem = (key) => storage.getItem(key)

const setItem = (key, val) => storage.setItem(key, val)

const getJSONItem = (key) => {
  const obj = storage.getItem(key)
  if (obj) {
    return JSON.parse(obj)
  } else {
    return obj
  }
}

const setJSONItem = (key, object) =>
  setItem(key, JSON.stringify(object))


const deleteItem = (key) => {
  const i = getItem(key)
  storage.removeItem(key)
  return i
}

const removeItem = (key) => storage.removeItem(key)

const migrateAddresses = () => {
  // const needsMigration = !getItem('deliveryAddress') && (!!localStorage['address.city'])
  // TODO: add this, after Delivery is modified to use the new Address component
}

const migrateUsers = () => {
  const needsMigration = !getJSONItem('user') && (!!getItem( 'user.phone' ))
  if (needsMigration) {
    console.log("Migration - migrateUsers")
    const user = {
      email: deleteItem('user.email'),
      fullName: deleteItem('user.full_name'),
      parsedPhone: deleteItem('user.phone'),
      subscribed: deleteItem('user.subscribed')
    }
    setJSONItem("user", user)
  }
}
const migrateAgreements = () => {
  const user = getJSONItem("user")
  const agreement = getJSONItem("agreement")
  const needsMigration = !agreement && (user && !!user.parsedPhone)
  if (needsMigration) {
    console.log("Migration - migrateAgreements")
    const agreement = {
      subscribed: user.subscribed,
      tosAgreement: true
    }
    setJSONItem("agreement", agreement)
  }
}


const migrate = () => {
}

export default {
  setItem,
  getItem,
  setJSONItem,
  getJSONItem,
  // deleteItem returns the deleted item
  deleteItem,
  // removeItem will delete the item, but not return it
  removeItem,
  migrate
}
